<template>
  <v-app light>
    <v-app-bar
      app
      id="toolbar"
      style="top: 0; z-index: 100; width: 100%;"
      color="white"
      height="max-content"
    >
      <v-toolbar-title class="ml-lg-12">
        <router-link to="/">
          <svg
            id="logo"
            width="90px"
            viewBox="0 0 540 540"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <defs>
              <!-- This clip path is for clipping images in extra-sections -->
              <clipPath id="sparkle_path" transform="scale(0.52)">
                <polygon
                  points="269.934,19.351 287.238,1 302.053,21.414 321.562,5.425 333.644,27.567 355.037,14.206 364.188,37.708 
	387.115,27.192 393.187,51.673 417.27,44.175 420.16,69.23 445.005,64.874 444.667,90.093 469.862,88.948 466.306,113.919 
	491.442,116.005 484.719,140.315 509.382,145.6 499.604,168.852 523.39,177.247 510.721,199.056 533.237,210.423 517.883,230.433 
	538.76,244.586 520.974,262.47 539.868,279.177 519.942,294.637 536.545,313.624 514.805,326.409 528.846,347.364 505.647,357.266 
	516.894,379.842 492.621,386.694 500.887,410.523 475.937,414.218 481.088,438.906 455.867,439.383 457.819,464.527 
	432.748,461.771 431.467,486.961 406.955,481.021 402.462,505.841 378.913,496.814 371.283,520.854 349.078,508.892 
	338.439,531.761 317.946,517.058 304.471,538.376 286.027,521.172 269.934,540.594 253.841,521.172 235.396,538.376 
	221.922,517.058 201.429,531.761 190.789,508.892 168.585,520.854 160.956,496.814 137.402,505.841 132.914,481.021 
	108.398,486.961 107.12,461.771 82.048,464.527 83.999,439.383 58.781,438.906 63.932,414.218 38.981,410.523 47.247,386.694 
	22.975,379.842 34.221,357.266 11.021,347.364 25.063,326.409 3.323,313.624 19.926,294.637 0,279.177 18.895,262.47 1.107,244.586 
	21.985,230.433 6.63,210.423 29.146,199.056 16.479,177.247 40.263,168.852 30.486,145.6 55.149,140.315 48.426,116.005 
	73.563,113.919 70.005,88.948 95.201,90.093 94.864,64.874 119.708,69.23 122.599,44.175 146.682,51.673 152.752,27.192 
	175.679,37.708 184.832,14.206 206.224,27.567 218.306,5.425 237.815,21.414 252.629,1 "
                />
              </clipPath>
            </defs>
            <polygon
              id="Sparkle"
              v-bind:style="{
                animationPlayState: $root.loading ? 'running' : 'paused',
              }"
              fill="#00C5FF"
              points="235.606,44.122 190.124,13.024 170.062,64.339 117.434,48.03 113.389,102.979 
	58.291,102.906 70.623,156.605 17.952,172.776 45.563,220.456 0,251.434 40.437,288.856 6.029,331.889 55.701,355.729 
	35.504,406.99 89.996,415.13 85.807,470.067 140.278,461.784 152.468,515.517 202.077,491.546 229.563,539.299 269.903,501.769 
	310.243,539.299 337.728,491.546 387.337,515.517 399.528,461.784 453.998,470.067 449.809,415.13 504.301,406.99 484.104,355.729 
	533.777,331.889 499.367,288.856 539.807,251.434 494.242,220.456 521.854,172.776 469.182,156.605 481.514,102.906 
	426.415,102.979 422.372,48.03 369.743,64.339 349.682,13.024 304.198,44.122 269.903,1 "
            />
            <g id="ExtraPostRU" v-if="$i18n.locale === 'ru'">
              <path
                id="ExtraRU"
                display="inline"
                fill="#FFFFFF"
                d="M103.092,181.139c7.291-4.456,15.087-5.266,19.644-5.266
		c11.442,0,19.138,5.063,23.694,9.822c5.367,5.67,8.708,13.366,8.708,23.694c0,12.657-5.063,23.188-13.062,30.377
		c-8,7.189-17.012,9.822-27.238,9.822c-7.898,0-13.974-1.417-19.543-5.367l1.519-12.758c2.835,3.139,8.505,8,19.036,8
		c7.291,0,14.075-2.126,19.644-7.898c3.038-3.139,6.278-7.898,7.493-14.682h-34.833l1.215-10.125h34.124
		c-0.304-5.063-2.228-10.024-5.164-13.467c-3.646-4.253-9.62-7.291-17.518-7.291c-8.101,0-14.683,3.848-19.239,8.101
		L103.092,181.139z M180.86,205.845l30.782-28.554h14.176l-35.845,32.402l27.34,38.478h-13.974l-23.593-34.022l-4.152,34.022
		h-10.936l8.708-70.88h10.936L180.86,205.845z M286.675,193.897c-2.734-2.937-8.506-7.898-19.037-7.898
		c-15.695,0-27.846,11.645-27.846,29.77c0,14.176,9.113,23.694,22.884,23.694c9.214,0,15.796-4.86,19.34-8.202l-1.62,12.961
		c-2.126,1.418-8.91,5.367-19.644,5.367c-11.442,0-19.138-5.063-23.694-9.822c-6.48-6.784-8.607-14.986-8.607-23.694
		c0-14.784,6.379-24.403,12.961-30.377c8-7.189,16.91-9.822,27.238-9.822c6.582,0,13.164,0.912,19.542,5.266L286.675,193.897z
		 M321.206,187.417l-7.493,60.754h-10.936l7.493-60.754h-16.201l1.215-10.125h43.338l-1.215,10.125H321.206z M363.229,177.291
		c4.962,0,10.733,0.506,15.695,4.151c5.568,4.05,6.986,10.43,6.986,15.492c0,6.987-2.633,13.366-8.506,17.518
		c-6.48,4.557-13.872,4.962-18.125,4.962h-4.86l-3.544,28.757H339.94l8.708-70.88H363.229z M355.635,209.288h4.86
		c10.329,0,14.48-5.67,14.48-11.948c0-10.024-9.924-9.923-12.151-9.923h-4.557L355.635,209.288z M432.287,230.957h-29.77
		l-9.924,17.214h-12.049l44.451-74.931l24.403,74.931h-11.746L432.287,230.957z M429.249,220.832l-7.594-23.897l-13.568,23.897
		H429.249z"
              />
              <path
                id="PostRU"
                display="inline"
                d="M162.611,289.706v77.043h-21.572v-58.553h-25.534v58.553H93.933v-77.043H162.611z
		 M170.868,328.228c0-20.582,13.208-40.723,41.383-40.723s41.383,20.141,41.383,40.723c0,20.581-13.207,40.723-41.383,40.723
		S170.868,348.809,170.868,328.228z M231.401,328.228c0-14.858-9.135-22.232-19.15-22.232s-19.151,7.374-19.151,22.232
		s9.135,22.232,19.151,22.232S231.401,343.086,231.401,328.228z M301.183,336.702c-7.925,1.101-9.575,1.101-14.418,1.101
		c-26.085,0-27.186-12.987-27.186-25.754v-22.343h21.572v19.261c0,5.943-0.11,11.557,11.887,11.557c1.761,0,3.962-0.33,8.145-0.771
		v-30.047h21.572v77.043h-21.572V336.702z M345.207,308.196h-16.949v-18.49h55.471v18.49h-16.949v58.553h-21.572V308.196z
		 M408.934,289.706h26.195l27.405,77.043h-23.113l-4.292-13.317h-26.195l-4.292,13.317h-23.113L408.934,289.706z M413.227,336.482
		h17.609l-8.805-28.396L413.227,336.482z"
              />
            </g>

            <g id="ExtraPost" v-else>
              <path
                id="Extra"
                fill="#FEFEFE"
                d="M419.332,247.795l-5.217-17.512h-29.65l-10.129,17.512h-11.668L407.324,173L431,247.795H419.332
		z M390.282,220.225h20.839l-7.232-22.728L390.282,220.225z M304.519,177.216l-1.411,10.058l-20.669,0.042l-8.488,60.523
		l-12.131-0.044l8.488-60.523h-21.175l1.412-10.058L304.519,177.216z M357.426,247.795l-11.798,0.044l-15.344-30.7
		c-1.434,0.104-8.595,0.13-8.595,0.13l-4.281,30.526h-10.587l9.898-70.581h18.749c17.204,0,22.189,10.058,20.795,19.998
		c-0.98,6.998-5.333,14.066-15.312,17.647L357.426,247.795z M323.092,207.271h3.529c15.387,0,18.43-5.587,19.056-10.058
		c0.627-4.471-1.473-9.94-12.832-9.94h-6.948L323.092,207.271z M233.15,247.796h-12.374l-12.683-25.254l-20.579,25.254h-13.498
		l28.65-36.236l-17.164-34.345h12.345l12.39,24.771l19.584-24.771h12.347l-27.143,34.346L233.15,247.796z M169.837,187.272h-31.762
		l-2.796,19.94h30.879l-1.411,10.057h-30.88l-2.87,20.468h31.762l-1.411,10.058H119l9.899-70.582h42.349L169.837,187.272z"
              />
              <path
                id="Post"
                d="M360.025,286.475H425v19.492h-21.658v67.139h-21.657v-67.139h-21.659V286.475z M317.671,308.151
		c0,13.353,39.472,13.717,39.472,40.405c0,28.775-45.321,37.814-64.285,11.417l16.481-12.077
		c8.601,12.077,24.761,10.628,24.761,0.317c0-12.063-39.16-14.776-39.16-40.327c0-14.381,15.428-24.996,32.161-23.794
		c9.464,0.677,17.562,5.056,22.687,11.278l-15.7,11.509l-0.013,0.004C324.996,299.58,317.671,303.729,317.671,308.151z
		 M286.623,329.789c0,25.119-21.333,45.482-47.647,45.482c-26.315,0-47.649-20.363-47.649-45.482
		c0-25.118,21.333-45.48,47.649-45.48C265.291,284.309,286.623,304.671,286.623,329.789z M262.787,329.789
		c0-13.127-10.685-23.813-23.812-23.813c-13.13,0-23.813,10.687-23.813,23.813c0,13.13,10.683,23.814,23.813,23.814
		C252.102,353.604,262.787,342.919,262.787,329.789z M157.349,286.542c21.29,0,28.973,16.299,28.969,28.498
		c0.004,12.198-7.679,28.497-28.969,28.497l-10.693,0.027v29.541H125v-86.622h7.236v-0.009l3.519,0.009h10.901v0.03L157.349,286.542
		z M166.845,315.044l0.021-0.009h-0.021c0-4.403-2.464-9.062-11.216-9.062l-8.973-0.004v18.14l8.973-0.004
		C164.38,324.105,166.845,319.447,166.845,315.044z"
              />
            </g>
          </svg>
        </router-link>
      </v-toolbar-title>

      <v-toolbar-items class="hidden-sm-and-down">
        <template v-for="(href, id) in menu">
          <v-btn small text :to="`/${$i18n.locale}${href}`" :key="id">{{
            $t(id)
          }}</v-btn>
        </template>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn text href="tel:+74991102326" id="phone_btn">
          <v-icon small class="mt-1" color="primary">mdi-phone</v-icon>&nbsp;+7
          499 110-23-26
        </v-btn>
      </v-toolbar-items>

      <v-menu left bottom class="hidden-md-and-up">
        <template v-slot:activator="{ on }">
          <v-btn
            id="mobile_menu_btn"
            x-large
            icon
            v-on="on"
            color="primary"
            class="hidden-md-and-up"
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list nav>
          <v-subheader>{{ $t("solutions") }}</v-subheader>
          <v-list-item
            v-for="(href, id) in mobileMenu"
            :to="`/${$i18n.locale}${href}`"
            :key="id"
          >
            <v-list-item-title class="ml-8">{{ $t(id) }}</v-list-item-title>
          </v-list-item>
          <v-subheader>{{ $t("contacts") }}</v-subheader>
          <v-list-item href="tel:+74991102326">
            <v-icon small class="mt-1 mr-3" color="primary">mdi-phone</v-icon>

            <v-list-item-title>+7 499 110-23-26</v-list-item-title>
          </v-list-item>
          <v-list-item to="demo_request">
            <v-icon class="mr-2" color="primary">touch_app</v-icon>
            <v-list-item-title>{{ $t("demo_request") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!--      <v-menu>
        <template v-slot:activator="{ on }">
          <v-btn x-large icon v-on="on" id="locale_btn">
            <flag :iso="langs[i18n.locale].flag" :squared="false" />
          </v-btn>
        </template>
        <v-list nav id="locale_menu">
          <v-list-item
            v-for="(lang, index) in langs"
            :key="lang.flag"
            @click="changeLocale(index)"
            :inactive="langs[i18n.locale] == lang"
          >
            <v-list-item-avatar>
              <flag :iso="lang.flag" v-bind:squared="false" />
            </v-list-item-avatar>
            <v-list-item-title>{{ lang.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> -->
    </v-app-bar>

    <v-content id="main-content">
      <v-overlay :value="$root.loading"></v-overlay>
      <transition name="slide-fade">
        <keep-alive max="12">
          <router-view></router-view>
        </keep-alive>
      </transition>
    </v-content>

    <v-footer color="#333" class="pl-md-12">
      <v-layout row wrap align-center>
        <v-flex xs12>
          <div class="ml-4">
            &copy; 2015&mdash;{{ new Date().getFullYear() }}
            {{ $t("extra_llc") }}
          </div>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
const BASE_URL = "https://extrapost.ru";
const DEFAULT_MENU = {
  widget: "/checkout",
  fulfillment: "/fulfillment",
};
const DEFAULT_MOBILE_MENU = {
  widget: "/checkout",
  fulfillment: "/fulfillment",
};

const DEFAULT_MENU_HEIGHT = 90;

export default {
  name: "App",
  data() {
    return {
      langs: {
        en: { flag: "gb", title: "English" },
        ru: { flag: "ru", title: "Русский" },
        zh: { flag: "cn", title: "简体中文" },
      },
      i18n: this.$i18n,
      menu: DEFAULT_MENU,
      mobileMenu: DEFAULT_MOBILE_MENU,
    };
  },

  head: function() {
    // Remove lang part of the path, i.e. '/ru'.
    var name = this.$route.name;

    // Try to get page-specific description and keywords here,
    // fallback to general description and keywords.
    var description =
      (name &&
        this.$i18n.te(name + "_description") &&
        this.$i18n.t(name + "_description")) ||
      this.$i18n.t("description");
    var keywords =
      (name &&
        this.$i18n.te(name + "_keywords") &&
        this.$i18n.t(name + "_keywords")) ||
      this.$i18n.t("keywords");

    var path = this.$route.fullPath.substring(3);
    var url = BASE_URL + this.$route.fullPath;
    return {
      title: {
        inner: this.$i18n.t(name),
        separator: "—",
        complement: this.$i18n.t("extrapost"),
      },
      meta: [
        {
          name: "description",
          content: description,
          id: "description",
        },
        {
          name: "keywords",
          content: keywords,
          id: "keywords",
        },
        {
          name: "og:title",
          content: this.$i18n.t(name) + " — " + this.i18n.t("extrapost"),
          id: "og-title",
        },
        {
          name: "og:description",
          content: description,
          id: "og-description",
        },
        {
          name: "application-name",
          content: this.$i18n.t("extrapost"),
          id: "application-name",
        },
        {
          name: "og:site_name",
          content: this.$i18n.t("extrapost"),
          id: "og-site_name",
        },
        {
          name: "og:url",
          content: url,
          id: "og-url",
        },
        {
          name: "og:locale",
          content: this.$i18n.locale,
          id: "og-locale",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: url,
          id: "canonical",
        },
        {
          rel: "alternate",
          hreflang: "en",
          href: BASE_URL + "/en" + path,
          id: "alt_en",
        },
        {
          rel: "alternate",
          hreflang: "ru",
          href: BASE_URL + "/ru" + path,
          id: "alt_ru",
        },
        {
          rel: "alternate",
          hreflang: "zh",
          href: BASE_URL + "/zh" + path,
          id: "alt_zh",
        },
      ],
    };
  },
  watch: {
    $route() {
      this.$emit("updateHead");
      const logoHeight =
        this.currentPageComponent().menuHeight || DEFAULT_MENU_HEIGHT;
      document.getElementById("logo").style.height = `${logoHeight}px`;
      document.getElementById("main-content").style.paddingTop = `${logoHeight +
        18}px`;

      this.menu = this.currentPageComponent().menu || DEFAULT_MENU;

      this.mobileMenu = this.currentPageComponent().menu || DEFAULT_MOBILE_MENU;
    },
  },

  mounted() {
    this.$emit("updateHead");
  },

  methods: {
    currentPageComponent() {
      return this.$route.matched[this.$route.matched.length - 1].components
        .default;
    },
    changeLocale(locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
        this.$vuetify.lang.current = locale;
        // Set lang cookie for ten years
        this.$cookie.set("currentLang", locale, 10 * 365);
        document.documentElement.lang = locale;
        const to = this.$router.resolve({ params: { lang: locale } });
        this.$router.push(to.location);
        this.$emit("updateHead");
      }
    },
  },
};

window.onscroll = function() {
  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    document.getElementById("main-content").style.paddingTop = "68px";
    document.getElementById("logo").style.height = "50px";
  } else {
    document.getElementById("logo").style.height = "90px";
    document.getElementById("main-content").style.paddingTop = "108px";
  }
};
</script>

<style>
html {
  scroll-padding-top: 63px;
  scroll-behavior: smooth;
}

/* Our custom tag for large headers */
h0 {
  font-size: 270% !important;
}

#logo {
  width: auto;
  min-width: 50px;
  margin-top: 7px;
  margin-right: 17px;
  transition: 0.3s;
}

/* Rotation animation for logo sparkle */
#Sparkle {
  -webkit-animation: spin 5s linear infinite;
  -moz-animation: spin 5s linear infinite;
  animation: spin 5s linear infinite;
  transform-origin: 270px 270px;
}

@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

#phone_btn {
  letter-spacing: normal;
}

#mobile_menu_btn {
  margin-right: 1.5em;
  height: auto;
}

#mobile_menu_btn .v-icon {
  font-size: 2.5em;
}

#locale_btn,
#locale_menu {
  font-size: 1.4em;
}

#locale_btn {
  margin-right: 9px;
}

#toolbar {
  max-height: 120px;
}

#toolbar .v-btn {
  height: 50px !important;
}

.v-toolbar__title {
  overflow: visible !important;
}

.v-footer {
  color: #999 !important;
  font-weight: 300;
  font-size: 80%;
}

.v-parallax__content {
  padding: 0 !important;
}

/* #hero {
  background: linear-gradient(
    1deg,
    rgba(0, 0, 0, 0) 68%,
    rgba(0, 0, 0, 0.76) 100%
  );
  background-color: rgba(0, 0, 0, 0.1);
} */

section.dark {
  background-color: #eeeeee;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(300px);
  opacity: 0;
}
</style>
